// extracted by mini-css-extract-plugin
module.exports = {"caption":"styles_caption__a2fnE"};